<template>
    <div class="supplier-recruitment-layout">
        <div class="header">
            <div class="header-left">
                <!-- 🔴 [Compass高危] S3/Venus 读取类域名，读操作当前可使用香港CDN，但需要关注后续团队规范 -->
                <img
                    src="https://s3-ap-hongkong.mykeeta.net/osg-eu-jiemo/keemart_header.png"
                />
            </div>
            <div class="header-right">
                <span>{{ operator }}</span>
                <mc-button
                    type="text"
                    @click="logout"
                >
                    {{
                        $getText("b_fe_vss__Quit_QGic", {
                            defaultValue: "Exit",
                            originValue: "退出",
                        })
                    }}
                </mc-button>
            </div>
        </div>
        <div class="content">
            <slot name="content">
            </slot>
        </div>
    </div>
</template>
<script setup>
import {
    ref, onMounted, getCurrentInstance,
} from 'vue';
import { getBizAccountApi, getMerchantStateApi } from './api';

const operator = ref('');

const { proxy } = getCurrentInstance();

// 退出登录
const logout = async () => {
    try {
        let logoutUrl = 'noMatch';
        const nodeEnv = process.env.NODE_ENV;
        if (nodeEnv === 'production') {
            logoutUrl = '/api/carrier/epassport/logout3797';
        } else {
            logoutUrl = '/api/carrier/epassport/logout4399';
        }
        logoutUrl = `${logoutUrl}?redirect_uri=${encodeURIComponent('/login.html')}`;
        window.location.href = `${window.location.origin}${logoutUrl}`;
    } catch (e) {
        proxy.$mc.message({ type: 'error', message: e.message || e.msg });
    }
};

onMounted(async () => {
    const { login } = await getBizAccountApi();
    operator.value = login;
    // 如果是已建立合作关系的供应商，不能进入到招商平台页面
    const { state } = await getMerchantStateApi();
    // 判断供应商是否入驻
    //  state 0-草稿 1-待审核 2-审核中 3-审核通过 4-审核不通过 5-已准入 999-当前账号存在供应商信息 -1-代表当前账号不存在招商信息
    if ([999].includes(+state)) {
        console.log('已建立合作关系的供应商，不能进入到招商平台页面');
        window.top.location.href = '/index.html';
    }
});
</script>
<style>
* {
    margin: 0;
    padding: 0;
}
</style>
<style lang="scss" scoped>
.supplier-recruitment-layout {
    height: 100vh;
    display: flex;
    flex-direction: column;
    position: relative;
    background: #F6F6F8;
    overflow-y: auto;
    .header {
        display: flex;
        flex-direction: row;
        height: 60px;
        align-items: center;
        justify-content: space-between;
        background-color: #fff;
        padding: 20px 16px 16px 16px;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        z-index: 10;
        .header-left {
            display: flex;
            align-items: center;
            img{
                display: inline-block;
                // width: 128px;
                // height: 44px;
                width: 110px;
            }
            span {
                font-size: 16px;
                line-height: 35px;
                color: #000000;
                letter-spacing: 0.89px;
            }
            .header-logo-line {
                margin: 0 12px;
                color: #B7BABD;
            }
        }
        .header-right {
            span {
                font-size: 15px;
            }
        }
    }
    .content {
        margin: 0 auto;
        padding-top: 60px;
        flex: 1;
    }
}
</style>
